<!-- id sits on the container, not the button: a labelable target would make the sibling <label for> fire the
     toggle a second time and the dropdown would never open. -->
<div class="dropdown-container" [id]="controlName">
  <div class="flex justify-start items-center space-x-1 mb-2">
    <span *ngIf="required" class="text-lg text-red-500 font-bold mr-1">*</span>
    <label
      *ngIf="showlabel"
      [for]="controlName"
      class="text-sm font-medium text-gray-700 dark:text-primary-100"
      (click)="toggleDropdown($event)"
      >{{ label }}</label
    >
    <app-info-tooltip
      *ngIf="tooltip"
      [tooltip]="tooltip"
      [tooltipPosition]="tooltipPosition"
      [tooltipClass]="tooltipClass"
    >
    </app-info-tooltip>
  </div>

  <div class="relative">
    <button
      type="button"
      (click)="toggleDropdown($event)"
      class="dropdown-select"
      aria-haspopup="listbox"
      aria-expanded="true"
      aria-labelledby="listbox-label"
    >
      <span class="block truncate font-normal text-gray-700">
        {{ selectedOption?.['name'] || placeholder }}
      </span>
      <span
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
      >
        <svg
          class="h-5 w-5 text-gray-400"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </button>

    <ul
      *ngIf="isOpen"
      class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
      tabindex="-1"
      role="listbox"
      aria-labelledby="listbox-label"
    >
      <li
        *ngFor="let option of options"
        (click)="selectOption(option)"
        [class.font-semibold]="option['id'] === formControl.value"
        class="relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-primary group"
      >

        <span class="block truncate group-hover:text-white">{{ option["name"] }}</span>

        <span *ngIf="option['id'] === formControl.value" class="absolute inset-y-0 right-0 flex items-center pr-4 text-primary group-hover:text-white">
          <svg
            class="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
              clip-rule="evenodd"
            />
          </svg>
        </span>

      </li>
    </ul>

    <div *ngIf="showIcon" class="hidden md:block absolute top-1/2 -translate-y-1/2" style="right: -30px;">
      <svg *ngIf="hasValue" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-6 stroke-2 text-green-500">
        <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd" />
      </svg>
      <svg *ngIf="!hasValue" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-6 text-amber-500">
        <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd" />
      </svg>
    </div>

  </div>

  <div class="pt-1" *ngIf="formControl.touched && formControl.invalid">
    <div
      class="ng-invalid input-error"
      *ngIf="formControl.errors?.['required']"
    >
      {{ label }} field is required.
    </div>
  </div>
</div>
